import { useAuthStore } from 'src/store/auth';

export interface ResetPasswordCredentials {
  password: string;
  confirmPassword: string;
}

export const useResetPassword = () => {
  const { resetPassword: resetPasswordAction, clear, isLoading, error, success } = useAuthStore();

  const resetPassword = async ({ password }: Omit<ResetPasswordCredentials, 'confirmPassword'> & { confirmPassword?: string }) => {
    const token = new URLSearchParams(window.location.search).get('token');
    const rpt = new URLSearchParams(window.location.search).get('rpt');

    if (!token) {
      console.error('Reset token not found in URL');
      return;
    }

    await resetPasswordAction({ token, password, rpt: rpt || '' });
  };

  return { clear, resetPassword, isLoading, error, success };
};
